module.exports = __webpack_public_path__ + "dwgfast_05.png?122bda1b14f4a58ba270dfc356bf6cac";


//////////////////
// WEBPACK FOOTER
// ./static/images/dwgfast_05.png
// module id = 15
// module chunks = 0 1